// extracted by mini-css-extract-plugin
export default {"Spinner":"SpinnerBar_Spinner__pZZw-","spinner":"SpinnerBar_spinner__Cs27L","Head":"SpinnerBar_Head__r0xUL"};